import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { FiledataApi } from "../services/akfenservicesprod/api";
import { Line } from "react-chartjs-2";

function Performance() {
  const fileDataProdApi = new FiledataApi({
    username: "akfeninsaat-avocet",
    password: "G*W8Cc/k?zK&Pp9",
  });

  let api = fileDataProdApi;

  //#region Page Property
  const { t, i18n } = useTranslation();
  const chartRef = useRef();
  const adrChartRef = useRef();
  const rentalIncomeChartRef = useRef();
  const rentalIncomeOtherChartRef = useRef();
  //#endregion

  const [headerOther, setHeaderOther] = useState([]);
  const [tableOther, setTableOther] = useState([]);
  const [numberOfRoomsData, setNumberOfRoomsData] = useState([]);
  const [selectedLang, setSelectedLang] = useState("");
  const [data, setData] = useState({
    datasets: [
      {
        fill: false,
        borderColor: "#E1E2E2",
        borderWidth: 1,
        pointRadius: 0,
      },
    ],
  });

  const [adrData, setAdrData] = useState({
    datasets: [
      {
        fill: false,
        borderColor: "#E1E2E2",
        borderWidth: 1,
        pointRadius: 0,
      },
    ],
  });

  const [rentalIncomeData, setRentalIncomeData] = useState({
    datasets: [
      {
        fill: false,
        borderColor: "#E1E2E2",
        borderWidth: 1,
        pointRadius: 0,
      },
    ],
  });

  const [otherRentalIncomeData, setOtherRentalIncomeData] = useState({
    datasets: [
      {
        fill: false,
        borderColor: "#E1E2E2",
        borderWidth: 1,
        pointRadius: 0,
      },
    ],
  });

  const number_format = (number, decimals, dec_point, thousands_sep) => {
    number = (number + "").replace(",", "").replace(" ", "");
    const n = !isFinite(+number) ? 0 : +number;
    const prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
    const sep = thousands_sep ?? ",";
    const dec = dec_point ?? ".";
    const toFixedFix = (n, prec) => {
      const k = Math.pow(10, prec);
      return "" + Math.round(n * k) / k;
    };

    let s = [];
    s = (prec ? toFixedFix(n, prec) : "" + Math.round(n)).split(".");
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || "").length < prec) {
      s[1] = s[1] || "";
      s[1] += new Array(prec - s[1].length + 1).join("0");
    }
    return s.join(dec);
  };

  const chartOptions = {
  maintainAspectRatio: false,
  responsive: true,
    plugins: {
      tooltip: {
        mode: "index",
        intersect: false,
        callbacks: {
          label: (context) => {
            const datasetLabel = context.dataset.label || "";
            return (
              datasetLabel +
              ": " +
              number_format(Number(context.parsed.y), 0, ".", ",")
            );
          },
        },
      },
      legend: {
        display: true, // legend'ı açar
        position: "top",
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          color: "#000",
          font: {
            size: 13,
          },
        },
      },
      y: {
        beginAtZero: true,
        grid: {
          color: "#E1E2E2",
        },
        ticks: {
          beginAtZero: true,
          color: "#000",
          font: {
            size: 12,
          },
          padding: 15,
        },
      },
    },
    elements: {
      point: {
        radius: 0,
      },
    },
  };

  const otherChartOptions = {
      maintainAspectRatio: false,
  responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        mode: "index",
        intersect: false,
        callbacks: {
          label: (context) => {
            const datasetLabel = context.dataset.label || "";
            return (
              datasetLabel +
              ": " +
              number_format(Number(context.parsed.y), 0, ".", ",")
            );
          },
        },
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          color: "#000",
          font: {
            size: 13,
          },
          precision: 0,
        },
      },
      y: {
        grid: {
          color: "#E1E2E2",
        },
        title: {
          display: true,
          text: t("Thousand"),
        },
        ticks: {
          beginAtZero: true,
          color: "#000",
          font: {
            size: 12,
          },
          padding: 15,
          callback: (value) => {
            const numValue = Number(value);
            if (numValue >= 1000) {
              return numValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
            return numValue;
          },
        },
      },
    },
    elements: {
      point: {
        radius: 0,
      },
    },
  };

  const pageData = () => {
    if (api !== undefined && api !== "") {
      api
        .apiFiledataPerformanceGet(selectedLang === "tr-TR" ? 1 : 2)

        .then((response) => {
          if (response.status === 200) {
            let datas = response.data;
            
            let solidity_ratio;
            let price_per_room;
            let rental_income;
            let other_rental_income;
            let number_rooms;

            if (selectedLang === "tr-TR") {
              solidity_ratio = "% Doluluk Oranı";
              price_per_room = "Oda Başı Fiyat";
              rental_income = "Kira Geliri";
              other_rental_income = "Diğer Kira Gelirleri";
              number_rooms = "Oda Sayısı";
            } else {
              solidity_ratio = "Occ Rate";
              price_per_room = "ADR";
              rental_income = "Rental Income";
              other_rental_income = "Other Rent Income";
              number_rooms = "Number of Rooms";
            }

            //#region occ_Rate // Doluluk Oranı
            var occ_Rate = datas[solidity_ratio];
            var occ_RateHeader = datas["Header"];
            var occRateDataSet = [];
            Object.entries(occ_Rate).map((item, i) => {
              let lbl =
                selectedLang === "tr-TR"
                  ? item[0]
                      .replace("Total", "Toplam")
                      .replace("Turkey", "Türkiye")
                      .replace("Russia", "Rusya")
                  : item[0];

              let color = dynamicColors(item[0]);
              occRateDataSet.push({
                fill: false,
                borderColor: color,
                backgroundColor: color,
                borderWidth: 1,
                lineTension: false,
                label: lbl,
                data: item[1],
              });
            });

            const newChartData = {
              labels: occ_RateHeader,
              datasets: occRateDataSet,
            };
            setData(newChartData);

            //#endregion

            //#region Oda Sayısı

            let numberOfRooms = datas[number_rooms];
            let norData = [];
            Object.entries(numberOfRooms).map((item) => {
              let nData = item[1];
              norData.push({
                category: item[0]
                  .replace("Total", "Toplam")
                  .replace("Turkey", "Türkiye")
                  .replace("Russia", "Rusya"),
                data: nData[nData.length - 1],
              });
            });
            setNumberOfRoomsData(norData);

            //#endregion

            //#region ADR / Oda Fiyatı
            var adr = datas[price_per_room];

            var adrDataSet = [];
            Object.entries(adr).map((item, i) => {
              let lbl =
                selectedLang === "tr-TR"
                  ? item[0]
                      .replace("Total", "Toplam")
                      .replace("Turkey", "Türkiye")
                      .replace("Russia", "Rusya")
                  : item[0];

              let color = dynamicColors(item[0]);
              adrDataSet.push({
                fill: false,
                borderColor: color,
                backgroundColor: color,
                borderWidth: 1,
                lineTension: false,
                label: lbl,
                data: item[1],
              });
            });

            const adrChartData = {
              labels: occ_RateHeader,
              datasets: adrDataSet,
            };
            setAdrData(adrChartData);

            //#endregion

            //#region ADR / Oda Fiyatı
            var rIncome = datas[rental_income];

            var rIncomeDataSet = [];
            Object.entries(rIncome).map((item, i) => {
              let lbl =
                selectedLang === "tr-TR"
                  ? item[0]
                      .replace("Total", "Toplam")
                      .replace("Turkey", "Türkiye")
                      .replace("Russia", "Rusya")
                      .replace("Other Rent Income", "Diğer Kira Geliri")
                  : item[0];

              let color = dynamicColors(item[0]);

              item[1] = item[1].map((item) => {
                return parseFloat(item) / 1000;
              });

              rIncomeDataSet.push({
                fill: false,
                borderColor: color,
                backgroundColor: color,
                borderWidth: 1,
                lineTension: false,
                label: lbl,
                data: item[1],
              });
            });

            const rentalIncomeChartData = {
              labels: occ_RateHeader,
              datasets: rIncomeDataSet,
            };
            setRentalIncomeData(rentalIncomeChartData);

            //#endregion

            //#region Other
            let otherChartData = datas["otherChart"];
            otherChartData = otherChartData.map((item) => {
              return parseFloat(item) / 1000;
            });
            let labels = datas["HeaderOtherChart"];
            const newOtherChartData = {
              labels: labels,
              datasets: [
                {
                  data: otherChartData,
                  fill: false,
                  borderColor: "#CC2D41",
                  backgroundColor: ["#CC2D41"],
                  borderWidth: 1,
                  pointRadius: 0,
                  label: t("RentlncomeText"),
                },
              ],
            };
            setOtherRentalIncomeData(newOtherChartData);
            //#endregion

            //#region Table
            let tableHeader = datas["HeaderOther"];
            let tableData = datas["Diğer Kira Gelirleri"];
            setHeaderOther(tableHeader);

            let other = [];
            Object.entries(tableData).map((item, i) => {
              other.push({ category: item[0], data: item[1] });
            });
            console.log(other);
            setTableOther(other);
            //#endregion
          }
        });
    }
  };

    //#region Format Number
  const formatNumber = (number) => {
    debugger;
    console.log(number);

    if(number.toString() === "NaN")
      return "";
    return number.toLocaleString("en-US", {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };
  //#endregion
  
  const dynamicColors = (name) => {
    if (name == "Turkey Ibis" || name == "Türkiye Ibis") return "rgb(192,0,0)";
    else if (name == "Turkey Novotel" || name == "Türkiye Novotel")
      return "rgb(127,151,195)";
    else if (name == "Russia Ibis" || name == "Rusya Ibis")
      return "rgb(255,93,93)";
    else if (name == "Tr & Ru Total" || name == "Tr & Ru Toplam")
      return "rgb(64,64,64)";

    var r = Math.floor(Math.random() * 255);
    var g = Math.floor(Math.random() * 255);
    var b = Math.floor(Math.random() * 255);
    return "rgb(" + r + "," + g + "," + b + ")";
  };

  useEffect(() => {
    if (window.location.pathname.indexOf("performance") !== -1) {
      i18n.changeLanguage("en");
      setSelectedLang("en-US");
    } else {
      i18n.changeLanguage("tr");
      setSelectedLang("tr-TR");
    }
  }, []);

  useEffect(() => {
    if (selectedLang !== "") pageData();
  }, [selectedLang]);

  return (
    <div className="performance">
      <div className="pageHeader mb-4">
        <div className="title"> {t("PerformanceHeader")}</div>
      </div>
      <div className="row mb-3">
        <div className="col-md-12">
          <div className="pageArea d-inline-block position-relative w-100 ">
            <div className="item">
              {data?.datasets?.length > 0 && (
                <>
                  <div className="chart_title text-center">
                    <span className="d-inline-block position-relative pb-2">
                      {t("SolidityRatio")}
                    </span>
                  </div>
                  <div
                    style={{ width: "100%", height: "287px" }}
                    className=" d-block"
                  >
                    <Line
                      className="mb-5"
                      ref={chartRef}
                      data={data}
                      options={chartOptions}
                    />
                  </div>

                  <div className="options d-inline-block position-relative w-100 text-center">
                    {numberOfRoomsData.map((item, i) => (
                      <>
                        <div
                          key={i}
                          className="item d-inline-block position-relative me-5"
                        >
                          <div className="chartTitle">{item.category}</div>
                          <div className="attr">
                            {t("numberofroom")}: {item.data}
                          </div>
                        </div>
                      </>
                    ))}
                  </div>
                </>
              )}

              {adrData?.datasets?.length > 0 && (
                <>
                  <div className="chart_title text-center">
                    <span className="d-inline-block position-relative pb-2">
                      {t("PricePerRoom")}
                    </span>
                  </div>

                  <div
                    style={{ width: "100%", height: "287px" }}
                    className=" d-block"
                  >
                    <Line
                      className="mb-5"
                      ref={adrChartRef}
                      data={adrData}
                      options={chartOptions}
                    />
                  </div>

                  <div className="options d-inline-block position-relative w-100 text-center">
                    {numberOfRoomsData.map((item, i) => (
                      <>
                        <div
                          key={i}
                          className="item d-inline-block position-relative me-5"
                        >
                          <div className="chartTitle">{item.category}</div>
                          <div className="attr">
                            {t("numberofroom")}: {item.data}
                          </div>
                        </div>
                      </>
                    ))}
                  </div>
                </>
              )}

              {rentalIncomeData?.datasets?.length > 0 && (
                <>
                  <div className="chart_title text-center">
                    <span className="d-inline-block position-relative pb-2">
                      {t("AkfenRentalIncome")}
                    </span>
                  </div>

                  <div
                    style={{ width: "100%", height: "287px" }}
                    className=" d-block"
                  >
                    <Line
                      className="mb-5"
                      ref={rentalIncomeChartRef}
                      data={rentalIncomeData}
                      options={chartOptions}
                    />
                  </div>

                  <div className="options d-inline-block position-relative w-100 text-center">
                    {numberOfRoomsData.map((item, i) => (
                      <>
                        <div
                          key={i}
                          className="item d-inline-block position-relative me-5"
                        >
                          <div className="chartTitle">{item.category}</div>
                          <div className="attr">
                            {t("numberofroom")}: {item.data}
                          </div>
                        </div>
                      </>
                    ))}
                  </div>
                </>
              )}

              <div className="chart_title text-center">
                <span className="d-inline-block position-relative pb-2">
                  {t("RentalIncomeHeader")}
                </span>
              </div>

              <div className="otherTable overflow-auto">
                <table className="w-100">
                  <thead>
                    <tr>
                      <td> </td>
                      {headerOther.map((item) => (
                        <td className="text-center"> {item}</td>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {tableOther.map((item, key) => (
                      <tr key={key}>
                        <td>{item.category}</td>
                        {item.data.map((dataItem, dataKey) => (
                          <td key={key + dataKey}>{formatNumber(parseFloat(dataItem))}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {otherRentalIncomeData?.datasets?.length > 0 && (
                <>
                  <div
                    style={{ width: "100%", height: "287px" }}
                    className=" d-block mt-3"
                  >
                    <Line
                      className="mb-5"
                      ref={rentalIncomeOtherChartRef}
                      data={otherRentalIncomeData}
                      options={otherChartOptions}
                    />
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Performance;
